import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './RejectedAccreditationsManagementComponent.css';
import _ from 'lodash';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import RejectedAccreditationsByValidatorsList from '../accreditationsList/RejectedAccreditationsByValidatorsList.container';
import RejectedAccreditationsByApplicantsList from '../accreditationsList/RejectedAccreditationsByApplicantsList.container';
import { REJECTED_BY_VALIDATORS, REJECTED_BY_APPLICANTS } from './../../../reducers/accreditation/accreditations';
import {NOTIFICATION_TYPES} from "../../../constants/constants";

class RejectedAccreditationsManagementComponent extends Component {
    componentDidMount() {
        if (!_.isNil(this.props.groupId)) {
            this.props.onGetNotifications(this.props.groupId);
        }
    }

    componentWillUpdate(nextProps) {
        if (this.props.groupId !== nextProps.groupId) {
            this.props.onGetNotifications(nextProps.groupId);
        }
    }

    render() {
        return (
            <div className="rejected-accreditations-management-container">
                <h4 className="page-label">{_.get(this.props.translation, 'accreditation_list.label')}</h4>
                <div className="rejected-accreditations-management-menu">
                    <div className="rejected-accreditations-mode-label">{_.get(this.props.translation, 'accreditation_list.show_accreditations_by_label')}</div>
                    <div className={"rejected-accreditations-mode-icon-container "+ (this.props.rejectedBy === REJECTED_BY_VALIDATORS ? " olive-green" : "")}
                         onClick={this.handleChangeMode(REJECTED_BY_VALIDATORS)}>
                        <IconContainer
                            className="rejected-accreditations-mode-icon"
                            icon={"radio_button_" + (this.props.rejectedBy === REJECTED_BY_VALIDATORS ? "checked" : "unchecked")}
                            title={_.get(this.props.translation, 'accreditation_list.validators_label')}
                        />
                        {_.get(this.props.translation, 'accreditation_list.validators_label')}
                        {this.getNotificationLabel(NOTIFICATION_TYPES.REJECTED_BY_VALIDATORS_ACCREDITATIONS)}
                    </div>
                    <div className={"rejected-accreditations-mode-icon-container" + (this.props.rejectedBy === REJECTED_BY_APPLICANTS ? " olive-green" : "")}
                         onClick={this.handleChangeMode(REJECTED_BY_APPLICANTS)}>
                        <IconContainer
                            className="rejected-accreditations-mode-icon"
                            icon={"radio_button_" + (this.props.rejectedBy === REJECTED_BY_APPLICANTS ? "checked" : "unchecked")}
                            title={_.get(this.props.translation, 'accreditation_list.applicants_label')}
                        />
                        {_.get(this.props.translation, 'accreditation_list.applicants_label')}
                        {this.getNotificationLabel(NOTIFICATION_TYPES.REJECTED_BY_APPLICANTS_ACCREDITATIONS)}
                    </div>
                </div>
                {this.renderContent()}
            </div>
        );
    }

    getNotificationLabel = (type) => {
        if (_.isNil(this.props.notifications) || _.isNil(this.props.notifications[type])) {
            return null;
        }

        return ` (${this.props.notifications[type]})`;
    };

    renderContent = () => {
        switch (this.props.rejectedBy) {
            case REJECTED_BY_VALIDATORS:
                return <RejectedAccreditationsByValidatorsList />;
            case REJECTED_BY_APPLICANTS:
                return <RejectedAccreditationsByApplicantsList />;
            default:
                break;
        }
    };

    handleChangeMode = (value) => () => {
        this.props.onChangeRejectedBy(value);
        this.props.onClearCountryFilter();
    }
}

RejectedAccreditationsManagementComponent.propTypes = {
    rejectedBy: PropTypes.string.isRequired,
    translation: PropTypes.object.isRequired,
    notifications: PropTypes.object,
    groupId: PropTypes.string,
    onChangeRejectedBy: PropTypes.func,
    onGetNotifications: PropTypes.func.isRequired,
    onClearCountryFilter: PropTypes.func.isRequired,
};

export default RejectedAccreditationsManagementComponent;



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/rejectedAccreditationsManagementComponent/RejectedAccreditationsManagementComponent.js